import { render } from "./Important.vue?vue&type=template&id=fe32654c&scoped=true"
import script from "./Important.vue?vue&type=script&lang=js"
export * from "./Important.vue?vue&type=script&lang=js"

import "./Important.vue?vue&type=style&index=0&id=fe32654c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe32654c"]])

export default __exports__